import browserStorage from '@/services/browserStorage';
import { createSession, getUserData } from '@/services/apiMapper';
import { setAuthorizationToken } from '@/services/axios/authorization';
import { ACTION, TOKEN_KEY, DATA_KEY, VUEX_PERSIST_KEY } from './CONSTANTS';

export default {
  [ACTION.LOGIN]({ dispatch }, { rememberMe, ...data }) {
    return new Promise((resolve, reject) => {
      createSession(data)
        .then(({ realtor_contact: realtorContact, session }) => {
          dispatch(ACTION.SAVE, {
            token: session.token,
            data: realtorContact,
            rememberMe,
          });

          resolve(realtorContact);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [ACTION.LOGIN_VIA_CONNECT]({ dispatch }, { token }) {
    return new Promise((resolve, reject) => {
      getUserData({ token })
        .then(({ realtor_contact: realtorContact }) => {
          dispatch(ACTION.SAVE, {
            token,
            data: realtorContact,
            rememberMe: true,
          });

          resolve(realtorContact);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [ACTION.SAVE]({ commit }, { data, token, rememberMe }) {
    const appropriateStorage = browserStorage[rememberMe ? 'local' : 'session'];

    appropriateStorage.setItem(TOKEN_KEY, token);
    appropriateStorage.setItem(DATA_KEY, JSON.stringify(data));

    setAuthorizationToken(token);
    commit('setToken', token);
    commit('setData', data);
  },
  [ACTION.LOGOUT]({ commit }) {
    browserStorage.removeItem(TOKEN_KEY);
    browserStorage.removeItem(DATA_KEY);
    browserStorage.removeItem(VUEX_PERSIST_KEY);
    commit('setToken', '');
    commit('setData', {});
  },
};
